var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4617 8.63997L13.9336 6.29997L16.4617 3.96087V8.63997ZM11.9603 9.89996C11.9603 10.3968 11.5571 10.8 11.0603 10.8H2.96035C2.46355 10.8 2.06035 10.3968 2.06035 9.89996V2.69996C2.06035 2.20406 2.46355 1.79996 2.96035 1.79996H11.0603C11.5571 1.79996 11.9603 2.20406 11.9603 2.69996V9.89996ZM17.3718 1.9314C16.8084 1.6857 16.155 1.7928 15.7059 2.2068L13.761 4.0068V2.7C13.761 1.2114 12.5496 0 11.061 0H2.96099C1.47239 0 0.260986 1.2114 0.260986 2.7V9.9C0.260986 11.3895 1.47239 12.6 2.96099 12.6H11.061C12.5496 12.6 13.761 11.3895 13.761 9.9V8.5941L15.7059 10.3932C15.9939 10.6605 16.3674 10.8 16.7481 10.8C16.9587 10.8 17.1702 10.7577 17.3718 10.6695C17.9199 10.4301 18.261 9.918 18.261 9.3339V3.267C18.261 2.6829 17.9199 2.1708 17.3718 1.9314Z",
    fill: "#505050"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/Camera.39e066cfab4f2b5042aa6f976bda7255.svg";
export { ForwardRef as ReactComponent };